export default __webpack_public_path__ + "static/media/minturPyColor.ce29a89e.svg";